export default {
  path: '/scheme/share/:id',
  name: 'Scheme.Share',
  component: () => import(/* webpackChunkName: "form" */ '@/views/modules/scheme/share/Share.vue'),
  hiddenInMenu: true,
  meta: {
    title: '方案秀分享',
    icon: 'database',
  },
};
